import { Container, Grid } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { HeaderHLPure, GridPure, ButtonHLPure } from "../../pures"
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout"
import './publicity-details.css'
import { useState, useEffect } from "react"

const PublicityDetailsView = (props) => {
  const { t, i18n } = useTranslation('publicity', { keyPrefix: 'publicityInfoScreen' })
  const { t: tCommon } = useTranslation('common');

  const { publicityData: {
    name,
    startDate,
    url,
    endDate,
    description,
    imagePath,
    minAge,
    maxAge,
    publicityConsumerPreferences,
    publicityGenders,
    publicityBranchOffices
  } } = props;

  const formattedStartDate = /^\d{4}-\d{2}-\d{2}$/.test(startDate) ? startDate.split('-').reverse().join('/') : startDate.split('-').join('/')
  const formattedEndDate = /^\d{4}-\d{2}-\d{2}$/.test(endDate) ? endDate.split('-').reverse().join('/') : endDate.split('-').join('/')
  const consumerPreferences = publicityConsumerPreferences.map(({ consumerPreference }) => consumerPreference.name)
  const branchOffices = publicityBranchOffices.map(({ branchOffice }) => branchOffice)

  const [branchOfficesPublicity, setBranchOfficesPublicity] = useState(branchOffices);
  const [preferences, setPreferences] = useState([])
  const [genders, setGenders] = useState()

  useEffect(() => {
    if (consumerPreferences) {
      const auxPreferences = consumerPreferences.map((consumerPreference) => {
        return tCommon(consumerPreference.trim())
      })

      setPreferences(auxPreferences)
    }

    if (publicityGenders) {
      const auxGenders = publicityGenders.map((publicityGender) => {
        return tCommon(publicityGender.gender.name)
      }).join(', ')

      setGenders(auxGenders)
    }
  }, [i18n.language])

  return (
    <div className="publicityDetailsView">
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <HeaderHLPure title={t("mainTitle")} />
          </Grid>

          <Grid item xs={12}>
            <Container maxWidth={"md"}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <PanelBar>
                    <PanelBarItem title={t("expansionTitle1")} expanded>
                      <Grid container spacing={4} className="indentation-panel">
                        <Grid item xs={12} md={6} className="publicityDetailsView-column">
                          <p>
                            <span className="field-label">{t("publicityName")}</span>
                            <span className="field-value">{name}</span>
                          </p>
                          <p>
                            <span className="field-label">{t("publicityUrl")}</span>
                            <span className="field-value">{url}</span>
                          </p>
                          <p>
                            <span className="field-label">{t("publicityDescription")}</span>
                            <span className="field-value">{description}</span>
                          </p>
                        </Grid>

                        <Grid item xs={12} md={6} className="publicityDetailsView-column">
                          <p>
                            <span className="field-label">{t("publicityStartDate")}</span>
                            <span className="field-value">{formattedStartDate}</span>
                          </p>
                          <p>
                            <span className="field-label">{t("publicityEndDate")}</span>
                            <span className="field-value">{formattedEndDate}</span>
                          </p>
                          <p>
                            <span className="field-label">{t("publicityImage")}</span>
                            <img src={imagePath} className="image-container" />
                          </p>
                        </Grid>
                      </Grid>
                    </PanelBarItem>

                    <PanelBarItem title={t("expansionTitle2")}>
                      <Grid container spacing={2} className="indentation-panel">
                        <Grid item xs={12}>
                          <p className="field-label">{t("publicityConsumerPreferences")}</p>
                          <ul className="field-value preferences-list">
                            {preferences.map((item, index) => (
                              <li key={index} className="list-items">{item}</li>
                            ))}
                          </ul>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <p>
                            <span className="field-label">{t("publicityGenders")}</span>
                            <span className="field-value">{genders}</span>
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <p>
                            <span className="field-label">{t("publicityAges")}</span>
                            <span className="field-value">{minAge} {t("publicityAgesTo")} {maxAge} {t("publicityAgesRange")}</span>
                          </p>
                        </Grid>
                        <Grid item xs={12} style={{ display: 'grid' }}>
                          <p className="field-label">{t("publicityBranchOffices")}</p>
                          <GridPure
                            {...props}
                            dataGrid={branchOfficesPublicity}
                            setData={setBranchOfficesPublicity}
                            skip={0}
                            take={11}
                            rowsItems={[{
                              field: 'keyIdentifier',
                              sorteable: true,
                              title: t("publicityBranchOfficesKeyIdentifier"),
                              width: '20%'
                            },
                            {
                              field: 'name',
                              sorteable: true,
                              title: t("publicityBranchOfficesName"),
                              width: '40%'
                            }]}
                          />
                        </Grid>
                      </Grid>
                    </PanelBarItem>
                  </PanelBar>
                </Grid>

                <Grid item xs={12} justifyContent="flex-end" style={{ display: 'flex' }}>
                  <ButtonHLPure
                    primary outlined
                    nameBtn={t("publicityReturnButton")}
                    onClick={() => { props.handleReturn('/publicity') }}
                  />
                </Grid>
              </Grid>
            </Container>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export { PublicityDetailsView as default }